/**
 * Service for the register page commercial content (multilingual).
 * Mirrors loginPageContent.
 */
import useApi from '../utils/api';

class RegisterPageContentService {
  #prefix = '/registerPageContent';

  list = () => {
    return useApi.get(this.#prefix);
  };

  create = (data) => {
    return useApi.post(this.#prefix, data);
  };

  update = (id, data) => {
    return useApi.put(`${this.#prefix}/${id}`, data);
  };

  remove = (id) => {
    return useApi.delete(`${this.#prefix}/${id}`);
  };
}

export default new RegisterPageContentService();
